import {
	BrowserRouter as Router,
	Routes,
	Route,
	Link,
	useRouteMatch,
	useParams,
	useNavigate
} from "react-router-dom";
import Dashboard from './pages/Dashboard';
import User from "./pages/User";
import Order from "./pages/Order";
import Auth from "./pages/Auth";
import Customer from "./pages/Customers";
import Tarif from './pages/Tarif';
import Employee from "./pages/Employee";
import Directory from "./pages/Directory";
import Bonus from "./pages/Bonus";
import Box from "./pages/Box";
import ScannerPanel from "./pages/BoxDetail";
import SetUser from "./pages/SetUser";
import Partial from "./pages/Partial";
import Scun from "./pages/Scun";
import PartialDetail from "./pages/PartialDetail";
import AcceptBatch from "./pages/AcceptPartial";
import Shops from "./pages/Shops";
import Actions from "./pages/Actions";
import Warehouse from "./pages/Warehouse";
import Issue from "./pages/Issue";
import { ProtectedRoute } from "./ProtectedRoute";
import UserDetail from "./pages/UserDetail";
import DeliveryPage from "./pages/DeliverPage";
import QRScanner from "./pages/QRScanner";
import BuyForMe from "./pages/BuyForMe";
import UploadExcel from "./pages/uploadUsers";
import { useEffect } from "react";
import OrderProcess from "./pages/OrderProcess";
import AddOrder from "./components/common/AddOrder";
import BoxSeems from "./pages/BoxSeems";
import ScanReceive from "./pages/ScanReceive";
import OrderScanPage from "./pages/OrderScanPage";
import UserForWarehouse from "./pages/UserForWarehouse";
import Recievers from "./pages/Recipient";
import ScanDelivery from "./pages/ScanDelivery";
import Deliver from "./pages/Deliver";
import SearchDoctors from "./pages/ApiComponent";

const ROLES = {
	ADMIN: "admin",
	MANAGER: "manager",
	Warehouse: "Warehouse",
};



function Routers({ auth = true, role = "admin" }) {
	let navigate = useNavigate();
	useEffect(() => {
		if (!auth) navigate("/auth")
	}, [auth])
	return (
		<Routes>
			{!auth ? (
				<>
					<Route path="/auth" element={<Auth />} />
					<Route path="/" element={<Auth />} />
				</>
			) : (
				<>
					<Route path="/auth" element={<Auth />} />
					<Route path="/" element={<ProtectedRoute path="/" role={role} element={<Dashboard />} />} />
					<Route path="/users" element={<ProtectedRoute path="/users" role={role} element={<User />} />} />
					<Route path="/customer" element={<ProtectedRoute path="/customer" role={role} element={<Customer />} />} />
					<Route path="/tarif" element={<ProtectedRoute path="/tarif" role={role} element={<Tarif />} />} />
					<Route path="/employee" element={<ProtectedRoute path="/employee" role={role} element={<Employee />} />} />
					<Route path="/bonus" element={<ProtectedRoute path="/bonus" role={role} element={<Bonus />} />} />
					<Route path="/box" element={<ProtectedRoute path="/box" role={role} element={<Box />} />} />
					<Route path="/scan-receive" element={<ProtectedRoute path="/box" role={role} element={<ScanReceive />} />} />
					<Route path="/accept-delivery" element={<ProtectedRoute path="/box" role={role} element={<ScanDelivery />} />} />
					<Route path="/scannerPanel" element={<ProtectedRoute path="/scannerPanel" role={role} element={<ScannerPanel />} />} />
					<Route path="/order-sort" element={<ProtectedRoute path="/scannerPanel" role={role} element={<OrderScanPage />} />} />
					<Route path="/scannerPanel/:boxId" element={<ProtectedRoute path="/scannerPanel/:boxId" role={role} element={<ScannerPanel />} />} />
					<Route path="/box-seems/:boxId" element={<ProtectedRoute path="/box-seems/:boxId" role={role} element={<BoxSeems />} />} />
					<Route path="/setUser" element={<ProtectedRoute path="/setUser" role={role} element={<SetUser />} />} />
					<Route path="/setUser/:tcode" element={<ProtectedRoute path="/setUser/:tcode" role={role} element={<SetUser />} />} />
					<Route path="/store" element={<ProtectedRoute path="/store" role={role} element={<Shops />} />} />
					<Route path="/actions" element={<ProtectedRoute path="/actions" role={role} element={<Actions />} />} />
					<Route path="/warehouse/:employeeGuid" element={<ProtectedRoute path="/warehouse/:employeeGuid" role={role} element={<Warehouse />} />} />
					<Route path="/directory" element={<ProtectedRoute path="/directory" role={role} element={<Directory />} />} />
					<Route path="/partial/:type" element={<ProtectedRoute path="/partial/:type" role={role} element={<Partial />} />} />
					<Route path="/partial-detail/:id" element={<ProtectedRoute path="/partial-detail/:id" role={role} element={<PartialDetail />} />} />
					<Route path="/order/:id" element={<ProtectedRoute path="/order/:id" role={role} element={<Order />} />} />
					<Route path="/order-process/:id" element={<ProtectedRoute path="/order-process/:id" role={role} element={<OrderProcess />} />} />
					<Route path="/buyforme" element={<ProtectedRoute path="/buyforme/:id" role={role} element={<BuyForMe />} />} />
					<Route path="/accept-partial" element={<ProtectedRoute path="/accept-partial" role={role} element={<AcceptBatch />} />} />
					<Route path="/rscan" element={<ProtectedRoute path="/rscan" role={role} element={<AddOrder />} />} />
					<Route path="/issue" element={<ProtectedRoute path="/issue" role={role} element={<Issue />} />} />
					<Route path="/delivery" element={<ProtectedRoute path="/delivery" role={role} element={<Deliver />} />} />
					<Route path="/deliver" element={<ProtectedRoute path="/deliver" role={role} element={<DeliveryPage />} />} />
					<Route path="/qr-scanner" element={<ProtectedRoute path="/deliver" role={role} element={<QRScanner />} />} />
					<Route path="/user-detail" element={<ProtectedRoute path="/user-detail" role={role} element={<UserDetail />} />} />
					<Route path="/upload-user" element={<ProtectedRoute path="/upload-user" role={role} element={<UploadExcel />} />} />
					<Route path="/user-for-ware" element={<ProtectedRoute path="/user-for-ware" role={role} element={<UserForWarehouse />} />} />
					<Route path="/recievers" element={<ProtectedRoute path="/recievers" role={role} element={<Recievers />} />} />
					<Route path="/search" element={<ProtectedRoute path="/search" role={role} element={<SearchDoctors />} />} />
				</>
			)}
		</Routes>
	);
}


export default Routers;